/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default {
  algorithm: process.env.REACT_APP_ALGORITHM!,
  password: process.env.REACT_APP_PASSWORD!,
  backend: process.env.REACT_APP_BACKEND!,
  socketserver: process.env.REACT_APP_SOCKETSERVER!,
  allowMavis: process.env.REACT_APP_ALLOWMAVIS
}
